import React from "react";
import { useState, useEffect } from "react";
import {
    useGetpUserPermissionsQuery,
    useGetpUserPermissionsTypesQuery,
    useSendFormMutation,
    useGetPageQuery,
} from "../../redux/services/crmAPI";
import { succsesDataAddAlert } from "../../alerts/alerts";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import styles from "../currentManager/manager.module.css";

const Manager = () => {
    const navigate = useNavigate();

    const PingPermissions = useSelector((state) => state.status.permissions);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [isActive, setIsActive] = useState(0);
    const [permissionType, setPermissionType] = useState("1");
    const [permissionList, setPermissionList] = useState([]);
    const [storePermissionList, setStorePermissionList] = useState([]);

    const { data: permissions } = useGetpUserPermissionsQuery();
    const { data: permissionsTypes } = useGetpUserPermissionsTypesQuery();
    const { data: storePermissions } = useGetPageQuery("store-permissions");
    const { data: storePermissionDefault } = useGetPageQuery("store-permissions/default");
    const { data: stores } = useGetPageQuery("stores?per_page=200&all_stores=1");

    const [sendForm, { isLoading, isError, isSuccess }] = useSendFormMutation();

    const permissionHandler = (e) => {
        if (e.target.checked) {
            setPermissionList([...permissionList, e.target.value]);
        } else if (!e.target.checked) {
            setPermissionList([...permissionList.filter((id) => id !== e.target.value)]);
        }
    };

    useEffect(() => {
        if (isSuccess && !isLoading) {
            succsesDataAddAlert();
            navigate("/managers/1");
        }
    }, [isLoading]);

    const sendFormHandler = async () => {
        const formData = {
            user_permission_type_id: permissionType,
            name: name,
            email: email,
            phone: phone,
            active: isActive,
            password: password,
            user_permission_ids: permissionList,
            store_permissions: storePermissionList,
        };

        await sendForm({ body: formData, url: "users", method: "POST" }).unwrap();
    };

    const storePermissionHandler = (storeId, permissionId, e) => {
        if (e.target.checked) {
            const newStorePermissionList = JSON.parse(JSON.stringify(storePermissionList));
            const newPerm = newStorePermissionList.find((storPerm) => storPerm.id == storeId);
            newPerm.permissions[
                newPerm.permissions.findIndex((perm) => perm.store_permission_id === permissionId)
            ].active = true;
            console.log(newPerm);

            setStorePermissionList([...newStorePermissionList.filter((storPerm) => storPerm.id !== storeId), newPerm]);
        } else if (!e.target.checked) {
            const newStorePermissionList = JSON.parse(JSON.stringify(storePermissionList));
            const newPerm = newStorePermissionList.find((storPerm) => storPerm.id == storeId);
            newPerm.permissions[
                newPerm.permissions.findIndex((perm) => perm.store_permission_id === permissionId)
            ].active = false;
            console.log(newPerm);

            setStorePermissionList([...newStorePermissionList.filter((storPerm) => storPerm.id !== storeId), newPerm]);
        }
    };

    useEffect(() => {
        if (storePermissionDefault) {
            setStorePermissionList([...storePermissionDefault]);
        }
    }, [storePermissionDefault]);

    return (
        <>
            {permissions && permissionsTypes && storePermissions && stores && (
                <div className="content">
                    <div className="col-12">
                        <div id="page-header">
                            <h1>Новий менеджер</h1>
                        </div>
                        <input type="hidden" name="id" value="" />
                        <div className="row">
                            <div className="col-12 col-sm-6 col-lg-5">
                                <div className="card card-default">
                                    <div className="card-header">
                                        Інформація менеджера
                                        <div className="form-check float-end">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={isActive}
                                                onChange={(e) => setIsActive(+e.target.checked)}
                                            />
                                            <label className="form-check-label" for="check_enabled">
                                                Активний
                                            </label>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="mb-2">
                                            <label className="form-label">Тип</label>
                                            <select
                                                name="perm_type"
                                                className="form-select"
                                                value={permissionType}
                                                onChange={(e) => {
                                                    setPermissionType(e.target.value);
                                                }}
                                            >
                                                {permissionsTypes.map((permissionType) => {
                                                    return (
                                                        <option key={permissionType.id} value={permissionType.id}>
                                                            {permissionType.title}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                        <div className="mb-2">
                                            <label className="form-label">Ім'я</label>
                                            <input
                                                className="form-control"
                                                value={name}
                                                type="text"
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <label className="form-label">Email</label>
                                            <input
                                                className="form-control"
                                                value={email}
                                                type="email"
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <label className="form-label">Телефон</label>
                                            <input
                                                className="form-control"
                                                value={phone}
                                                type="text"
                                                onChange={(e) => setPhone(e.target.value)}
                                            />
                                        </div>

                                        <div className="mb-2">
                                            <label className="form-label">Пароль</label>
                                            <input
                                                className="form-control"
                                                value={password}
                                                type="password"
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {PingPermissions.includes("user_edit") || PingPermissions.includes("all") ? (
                                    <div className="saves_block">
                                        <button name="user_info" className="btn btn-primary" onClick={sendFormHandler}>
                                            {isLoading ? "Завантаження" : "Зберегти"}
                                        </button>
                                    </div>
                                ) : null}
                            </div>

                            <div className="col-12 col-sm-6 col-lg-7">
                                <div className="card card-default">
                                    <div className="card-header">Права менеджера</div>
                                    <div className="card-body">
                                        <ul className="order_details">
                                            {permissions.map((permission) => {
                                                return (
                                                    <li key={permission.id}>
                                                        <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                value={permission.id}
                                                                onChange={(e) => permissionHandler(e)}
                                                            />
                                                            <label className="form-check-label">
                                                                {permission.title}
                                                            </label>
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                </div>
                                <div className="card card-default">
                                    <div className="card-header">Доступ до магазинів/складів</div>
                                    <div className="card-body">
                                        <table
                                            className={"table table-striped " + styles.mobileFS + " " + styles.stickyThead}
                                            style={{ width: "100%" }}
                                        >
                                            <thead>
                                                <tr className="text-center">
                                                    <td></td>
                                                    {storePermissions.map((permission) => {
                                                        return (
                                                            <td key={permission.id} className="fit px-1">
                                                                {permission.title}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {stores.data.map((store, index) => {
                                                    return (
                                                        <tr key={store.id}>
                                                            <td>{store.title}</td>
                                                            {storePermissions.map((permission) => {
                                                                return (
                                                                    <td className="text-center" key={permission.id}>
                                                                        <div className="form-check d-flex justify-content-center align-items-center">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                value={permission.id}
                                                                                onClick={(e) =>
                                                                                    storePermissionHandler(
                                                                                        store.id,
                                                                                        permission.id,
                                                                                        e
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                );
                                                            })}
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Manager;
